var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"block"},[_c('span',{staticClass:"demonstration"},[_vm._v("折叠展示Tag")]),_vm._v(" "),_c('el-cascader',{attrs:{"options":_vm.options,"props":_vm.props,"collapse-tags":"","clearable":""},on:{"change":_vm.handleCascaderChange}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6231ab5e","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/diyu.vue
// module id = null
// module chunks = 